/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {TourType} from '../models/TourType';

export interface IsAiTourSuppressed$Request {
    tourType: TourType;
}

export interface IsAiTourSuppressed$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const isAiTourSuppressedRequest = createAction<PayloadData<void, IsAiTourSuppressed$Request>>('AI_TOUR_CONTROLLER__IS_AI_TOUR_SUPPRESSED__REQUEST');
export const isAiTourSuppressedSuccess = createAction<PayloadData<boolean, IsAiTourSuppressed$Request>>('AI_TOUR_CONTROLLER__IS_AI_TOUR_SUPPRESSED__SUCCESS');
export const isAiTourSuppressedFailure = createAction<PayloadData<Error, IsAiTourSuppressed$Request, true>>('AI_TOUR_CONTROLLER__IS_AI_TOUR_SUPPRESSED__FAILURE');

export const isAiTourSuppressedActions = [
    isAiTourSuppressedRequest,
    isAiTourSuppressedSuccess,
    isAiTourSuppressedFailure
] as const;

/**
 * @param {TourType} meta.tourType AI Tour Type
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const isAiTourSuppressed = (meta: IsAiTourSuppressed$Request, config?: IsAiTourSuppressed$Config) => {
    const TRANSPORT_GET_PARAMS = {
        tourType: meta.tourType,
    };
    return {
        CALL_API: {
            types: isAiTourSuppressedActions,
            method: ApiMethods.GET,
            endpoint: `/ai/tour/is-suppressed`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SuppressAiTour$Request {
    tourType: TourType;
}

export interface SuppressAiTour$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const suppressAiTourRequest = createAction<PayloadData<void, SuppressAiTour$Request>>('AI_TOUR_CONTROLLER__SUPPRESS_AI_TOUR__REQUEST');
export const suppressAiTourSuccess = createAction<PayloadData<void, SuppressAiTour$Request>>('AI_TOUR_CONTROLLER__SUPPRESS_AI_TOUR__SUCCESS');
export const suppressAiTourFailure = createAction<PayloadData<Error, SuppressAiTour$Request, true>>('AI_TOUR_CONTROLLER__SUPPRESS_AI_TOUR__FAILURE');

export const suppressAiTourActions = [
    suppressAiTourRequest,
    suppressAiTourSuccess,
    suppressAiTourFailure
] as const;

/**
 * @param {TourType} meta.tourType AI Tour Type
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const suppressAiTour = (meta: SuppressAiTour$Request, config?: SuppressAiTour$Config) => {
    const TRANSPORT_GET_PARAMS = {
        tourType: meta.tourType,
    };
    return {
        CALL_API: {
            types: suppressAiTourActions,
            method: ApiMethods.POST,
            endpoint: `/ai/tour/suppress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

